module.exports = __webpack_public_path__ + "static/headshot-mike-arpaia-3x.d5d0d653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-arpaia-3x.jpg
// module id = 127
// module chunks = 35783957827783 152909308826437